import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  padding: 0 15px;
  max-width: 950px;
  margin: 8vw auto 5vw;

  .row {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    ${bp('sm', 'min-width')`
      flex-direction: row;
      margin: 50px 0;
      align-items: center;
      grid-gap: 30px;
      font-size: 18px;
      line-height: 1.2;
      
      > * {
        flex: 1;
      }
    `}

    img {
      max-width: 100%;
    }

    h3 {
      margin: 10px 0;
      color: ${props => props.theme.productSelector.landingAccent};
      ${bp('sm', 'min-width')`
        padding: 0 32% 0 0;
      `}
    }

    &:first-of-type {
      h3 {
        color: ${props => props.theme.productSelector.darkBg};
      }
    }

    &:nth-of-type(2) {
      ${bp('sm')`
        flex-direction: column-reverse;
      `}

      h3 {
        color: ${props => props.theme.productSelector.checkColor};
      }
    }
  }
`
